export const isEmptyObject = (obj: Record<string, unknown> | undefined) =>
  !obj || Object.keys(obj).length === 0 || Object.values(obj).every((x) => !x);

export const groupBy = <T, K extends keyof any>(list: T[], getKey: (item: T, index: number) => K) =>
  list.reduce(
    (previous, currentItem, index) => {
      const group = getKey(currentItem, index);
      // eslint-disable-next-line no-param-reassign
      if (!previous[group]) previous[group] = [];
      previous[group].push(currentItem);
      return previous;
    },
    {} as Record<K, T[]>,
  );

export const chunkArray = <T>(arr: T[], chunckSize: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < Math.ceil(arr.length / chunckSize); i++) {
    chunks.push(arr.slice(i * chunckSize, (i + 1) * chunckSize));
  }
  return chunks;
};

export const hex2rgba = (hex: string, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g)?.map((x) => Number.parseInt(x, 16)) ?? [];
  return `rgba(${r},${g},${b},${alpha})`;
};

export function nonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}
